<template>
  <div>
    <div class="swiper-container1">
      <el-carousel type="card" height="500px">
        <el-carousel-item v-for="item in listData1" :key="item.id">
          <img :src="item.thumbnail_url" alt="" class="carousel-image" />
        </el-carousel-item>
      </el-carousel>

      <!-- <div class="swiper-wrapper">
        <div
          v-for="(item, index) in listData1"
          :key="index"
          class="swiper-slide"
        >
          <div class="slide_box">
            <img :src="item.thumbnail_url" alt="" />
          </div>
          <div class="slide_box">
            <img v-lazy="item.thumbnail_url" alt="" />
            <p class="title">{{ item.title }}</p>
            <p class="txt">{{ item.description }}</p>
            <div class="detail">
              <router-link :to="'/case/caseDetail?id=' + item.id"
                >查看详情</router-link
              >
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="swiper-button-prev"></div> -->
      <!-- <div class="swiper-button-next"></div> -->
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  name: "swiper_coverflow",
  data() {
    return {
      listData1: [
        {
          id: 1,
          title: "标题1",
          description: "描述1",
          thumbnail_url: require("../assets/milan/2备份 5.png"),
        },
        {
          id: 2,
          title: "标题2",
          description: "描述2",
          thumbnail_url: require("../assets/milan/2备份 6.png"),
        },
        {
          id: 3,
          title: "标题3",
          description: "描述3",
          thumbnail_url: require("../assets/milan/2备份 5 2.png"),
        },
      ],
    };
  },
  props: ["listData"],
  mounted() {},
  methods: {
    initSwiper: function () {
      new Swiper(".swiper-container1", {
        effect: "coverflow",
        slidesPerView: 5,
        loop: true,
        initialSlide: 2,
        centeredSlides: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        coverflowEffect: {
          rotate: 10,
          stretch: 5,
          depth: 60,
          modifier: 2,
          slideShadows: false,
        },
        observeParents: false, //注意这里！！
        observer: true, //也要注意这里！！
      });
    },
  },
  created() {
    this.initSwiper();
  },
};
</script>
<style lang="less" scoped>
.swiper-container1 {
  width: 1200px;
  // height: 320px;
  // margin: 60px auto 60px;
  margin: 30px auto 30px;
  padding: 40px 0px 120px 0px;
  overflow: hidden;
}
.slide_box {
  width: 100%;
  height: 100%;
  padding: 15px;
  // background: #fff;
  box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.1);
  img {
    // width: 100%;
    // height: 150px;
    width: 75%; /* 根据父元素的宽度按比例缩小 */
    height: auto; /* 自动调整高度以保持比例 */
  }
  p {
    text-align: left;
    &.title {
      font-size: 18px;
      margin-top: 15px;
      margin-bottom: 10px;
    }
    &.txt {
      font-size: 14px;
      color: #666;
      height: 45px;
      overflow: hidden;
    }
  }
  .detail {
    width: 80px;
    height: 35px;
    line-height: 35px;
    margin-top: 20px;
    background-color: #ff5b5a;
    a {
      display: block;
      color: #fff;
    }
  }
}
.swiper-button-prev {
  width: 50px;
  height: 50px;
  background-image: url(../../src/img/left-jt.png);
  background-size: 50px 50px;
  left: 520px;
  top: 450px;
}
.swiper-button-next {
  width: 50px;
  height: 50px;
  background-image: url(../../src/img/right-jt.png);
  background-size: 50px 50px;
  right: 520px;
  top: 450px;
}

.carousel-image {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  margin: 0 auto; /* 使图片居中 */
}
.el-carousel__item {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/swiperCover.vue